const psuedoClick = ( parentElem ) =>
{
    var beforeClicked,
        afterClicked;

    var parentLeft = parseInt(parentElem.getBoundingClientRect().left, 10),
        parentTop = parseInt(parentElem.getBoundingClientRect().top, 10);

    var parentWidth = parseInt(window.getComputedStyle(parentElem).width, 10),
        parentHeight = parseInt(window.getComputedStyle(parentElem).height, 10);

    var before = window.getComputedStyle(parentElem, ':before');

    var beforeStart = parentLeft + (parseInt(before.getPropertyValue("left"), 10)),
        beforeEnd = beforeStart + parseInt(before.width, 10);

    var beforeYStart = parentTop + (parseInt(before.getPropertyValue("top"), 10)),
        beforeYEnd = beforeYStart + parseInt(before.height, 10);

    var after = window.getComputedStyle(parentElem, ':after');

    var afterStart = parentLeft + (parseInt(after.getPropertyValue("left"), 10)),
        afterEnd = afterStart + parseInt(after.width, 10);

    var afterYStart = parentTop + (parseInt(after.getPropertyValue("top"), 10)),
        afterYEnd = afterYStart + parseInt(after.height, 10);

    var mouseX = event.clientX,
        mouseY = event.clientY;

    beforeClicked = (mouseX >= beforeStart && mouseX <= beforeEnd && mouseY >= beforeYStart && mouseY <= beforeYEnd ? true : false);

    afterClicked = (mouseX >= afterStart && mouseX <= afterEnd && mouseY >= afterYStart && mouseY <= afterYEnd ? true : false);

    return { "before" : beforeClicked, "after" : afterClicked };
}

function getClosestElement( event, elements )
{
    let closestElement = null;
    let closestDistance = Infinity;

    let calculateDistance = ( a, b ) =>
    {
        const dx = b.x - a.x;
        const dy = b.y - a.y;

        const distance = Math.sqrt(dx * dx + dy * dy);

        return distance;
    };

    elements.forEach( element =>
    {
        const distance = calculateDistance( { x: event.clientX, y: event.clientY }, element.getBoundingClientRect() );

        if( distance < closestDistance )
        {
            closestElement  = element;
            closestDistance = distance;
        }
    });

    return closestElement;
}

export default
{
    methods:
    {
        roundValue( value )
        {
            return Math.round(( Math.round( value / this.step ) * this.step ) * 100 ) / 100;
        },

        parseValue( value )
        {
            let $_value = { from: value.from, to: value.to };

            ( value.from < this.min ) && ( $_value.from = this.min );
            ( value.to > this.max ) && ( $_value.to = this.max );

            ( value.from > this.to ) && ( $_value.from = this.to );
            ( value.to < this.from ) && ( $_value.to = this.from );


            $_value.from = this.roundValue( $_value.from );
            $_value.to   = this.roundValue( $_value.to );

            return $_value;
        },

        emitValue( value )
        {
            if(
                value.from === this.modelValue.from &&
                value.to   === this.modelValue.to &&
                value.from >= this.min &&
                value.to   <= this.max
            )
            {
                return;
            }
            else
            {
                this.$emit( 'update:modelValue', this.parseValue( value ) );
            }
        },

        handleClick( event )
        {
            let isPseudoClicked = psuedoClick( this.$refs.rangeSliderElement );

            if( isPseudoClicked.before || isPseudoClicked.after )
            {
                if( this.showInputs )
                {
                    this.$refs.rangeSliderInputFrom.blur();
                    this.$refs.rangeSliderInputTo.blur();
                }

                let range  = this.$refs.rangeSliderElement,
                    touch  = ( event.type === 'touchstart' ),
                    eventX = ( touch ? event.touches[0].screenX : event.screenX ),
                    startX = event.offsetX;

                let handles = [...this.$refs.rangeSliderElement.querySelectorAll('.Range-slider-handle')];

                let handle = getClosestElement( event, handles );

                let index = handles.findIndex( h => h === handle );

                let prev = index > 0 ? handles[ index - 1 ] : null;
                let next = index < handles.length - 1 ? handles[ index + 1 ] : null;

                let minX = 0;
                let maxX = range.offsetWidth;

                let x = Math.min( maxX, Math.max( minX, ( startX + (( touch ? event.touches[0].screenX : event.screenX ) - eventX ))));

                let value = this.min + Math.round( x / range.offsetWidth * ( this.max - this.min ) / this.step ) * this.step;

                this.emitValue({ from: prev ? this.from : value, to: next ? this.to : value });
            }
        },

        handleDrag( event )
        {
            if( this.showInputs )
            {
                this.$refs.rangeSliderInputFrom.blur();
                this.$refs.rangeSliderInputTo.blur();
            }

            let range  = this.$refs.rangeSliderElement,
                handle = event.target,
                touch  = ( event.type === 'touchstart' ),
                eventX = ( touch ? event.touches[0].screenX : event.screenX ),
                startX = handle.offsetLeft;

            let handles = [...this.$refs.rangeSliderElement.querySelectorAll('.Range-slider-handle')];

            let index = handles.findIndex( h => h === handle );

            let prev = index > 0 ? handles[ index - 1 ] : null;
            let next = index < handles.length - 1 ? handles[ index + 1 ] : null;

            let minX = prev ? prev.offsetLeft : 0;
            let maxX = next ? next.offsetLeft + handle.offsetWidth : range.offsetWidth;

            const move = ( event ) =>
            {
                let x = Math.min( maxX, Math.max( minX, ( startX + (( touch ? event.touches[0].screenX : event.screenX ) - eventX ))));

                let value = this.min + Math.round( x / range.offsetWidth * ( this.max - this.min ) / this.step ) * this.step;

                this.emitValue({ from: prev ? this.from : value, to: next ? this.to : value });
            }

            function stop( event )
            {
                document.removeEventListener( touch ? 'touchmove' : 'mousemove', move, true );
                document.removeEventListener( touch ? 'touchend' : 'mouseup', stop, true );
            }

            document.addEventListener( touch ? 'touchmove' : 'mousemove', move, true );
            document.addEventListener( touch ? 'touchend' : 'mouseup', stop, true );
        },

        handleInputKeyDown( input, event )
        {
            if( [ 'ArrowUp', 'ArrowDown' ].includes( event.key ) )
            {
                let $_value = { from: this.from, to: this.to };

                if( event.key === 'ArrowUp' )   { $_value[ input ] += this.step }
                if( event.key === 'ArrowDown' ) { $_value[ input ] -= this.step }

                event.target.value = this.parseValue( $_value )[input];

                this.emitValue( $_value );

                event.preventDefault();
                event.stopPropagation();
            }
        }
    }
}